import { GutXAxisOrganList } from '@repo/ui';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useOrgans from 'services/organs/useOrgans';
import { useOrganSelect } from './hooks';
import styles from './OrganList.module.css';

/**
 * The tappable half of the card, below the breakpoint where the map goes inert.
 * Its divider separates it from the flag key above.
 */
export default function OrganList() {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const { organs } = useOrgans(currentKit?.id);
  const handleOrganSelect = useOrganSelect();

  return (
    <div className={styles.container}>
      <GutXAxisOrganList
        organs={organs}
        age={currentKit?.age_at_sampling ?? 0}
        pregnant={!!currentKit?.pregnant}
        sex={currentTinyAccount?.sex ?? 'M'}
        onOrganSelect={handleOrganSelect}
      />
    </div>
  );
}
